module.exports = __webpack_public_path__ + "img/stripe_logo.875a4de7.svg";